<template>
  <main :class="dynamic_row ? 'row' : ''">
    <div
      :class="dynamic_class ? 'col-md-10' : ''"
      style="padding-right:0px; margin-top: 85px"
    >
      <!-- Carousel -->
      <div
        id="carouselExampleIndicators"
        class="carousel slide custom-carousel"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              class="d-block w-100"
              src="../assets/slider/1.jpg"
              alt="First slide"
            />
          </div>
          <div class="carousel-item">
            <img
              class="d-block w-100"
              src="../assets/slider/2.jpg"
              alt="Second slide"
            />
          </div>
          <!-- <div class="carousel-item">
            <img
              class="d-block w-100"
              src="../assets/slider/1.png"
              alt="Third slide"
            />
          </div> -->
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div class="container-fluid" style="margin-top:30px">
        <span
          class="pull-right pointer"
          style="font-size:20px; font-weight:bold; color:#000; margin-top:15px"
          @click="scrollToElement()"
          >See more <i class="fa fa-caret-right"></i
        ></span>
        <h2 style="margin-bottom:25px">
          <span style="color: #F69325; font-weight: bold">Select </span>
          <span style="color:#000; font-weight: bold">Categories</span>
        </h2>
      </div>
      <Category />
      <div v-if="loading" class="text-center">
        <sweetalert-icon class="text-center" :icon="loadingType" />
        {{ loadingMessage }}
      </div>
      <!--  -->
      <div v-else>
        <div
          class="category-wise-item"
          v-for="onecategory in categorywiseprod"
          :key="onecategory[1]"
        >
          <Homeproduct
            :onecategory="onecategory"
            :productimageandname="productimageandname"
          />
        </div>
      </div>
      <div class="row" style="padding-bottom: 50px">
        <div
          class="row pt-5"
          style="text-align:center; width:100%; padding:0 ;margin:0"
        >
          <h1 style="width:100%; color: black;margin:0;font-weight:bold">
            Best Seller
          </h1>
        </div>
        <div class="row pt-3 p-5">
          <div class="col-md-4 col-xs-4 mb-4">
            <div class="col-xs-6">
              <img src="../assets/category/1.png" />
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6">
              <img src="../assets/category/2.png" />
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6">
              <img src="../assets/category/3.png" />
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6">
              <img src="../assets/category/2.png" />
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6">
              <img src="../assets/category/3.png" />
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6">
              <img src="../assets/category/1.png" />
            </div>
          </div>
        </div>
        <div class="row" style="width:100%; position: relative">
          <b-button
            style="position:absolute; left: 45%; top:30%; border: none; background-color: #F4933C; border-radius: 30px; padding: 5px 25px; font-size: 12px"
            >VIEW ALL</b-button
          >
        </div>
      </div>
      <!-- Services -->
      <div class="row">
        <div
          class="row pt-3 p-5"
          style=" position: relative; width:100%; padding:0 ;margin:0"
        >
          <h3 style="position:absolute; left: 44%; color: #F4933C">Services</h3>
        </div>
        <div
          class="row pb-3"
          style=" position: relative; width:100%; padding:0 ;margin:0"
        >
          <h1
            style="position:absolute; left: 35.5%; color: black; font-weight:bold"
          >
            Awesome Services
          </h1>
        </div>
        <div class="row pt-3 p-5 ">
          <div class="col-md-4 col-xs-4 mb-4">
            <div class="col-xs-6 xx">
              <img class="serviceimage" src="../assets/Rectangle@2x.png" />
              <div class="middle">
                <div class="text">
                  Contactless <br />
                  Delivery
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6 xx">
              <img class="serviceimage" src="../assets/Photo@2x.png" />
              <div class="middle">
                <div class="text">
                  Sanitized <br />
                  Essentials
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-4">
            <div class="col-xs-6 xx">
              <img class="serviceimage" src="../assets/Photo1.2.png" />
              <div class="middle">
                <div class="text">
                  Fast <br />
                  Delivery
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->
      <div class="row scroll-to-me">
        <div class="row pl-5" style="width:100%; padding:0 ;margin:0">
          <h2>
            <span style="color: #F69325; font-weight: bold">All </span>
            <span style="color:#000; font-weight: bold">Categories</span>
          </h2>
        </div>
        <div class="row pt-3 p-5">
          <div
            class="col-md-3 col-xs-3 mb-4"
            v-for="onecat in newcategory"
            :key="onecat.id"
          >
            <router-link :to="'/cat/' + onecat.id">
              <div class="card uppercat">
                <img class="card-img-top" style="" :src="onecat.image" />
                <div class="catname-custom">
                  <p style="font-size: 20px; font-weight: bold">
                    {{ onecat.name }}
                  </p>
                </div>
              </div>
            </router-link>
            <!-- <img :src="onecat.image"/> -->
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-2 col-sm-12 col-lg-2 media-query"
      v-if="user"
      style="background-color: rgb(248, 248, 248) !important;margin: 0px;padding: 0px;"
    >
      <Cart />
    </div>
  </main>
</template>

<script>
import { dbFs, db } from "@/modules/database";
import { mapGetters } from "vuex";
import Cart from "@/components/Cart.vue";
import { getCart, addToCart } from "@/modules/cart";
import Category from "../components/Category";
// import Homeproduct from "../components/Homeproduct";

export default {
  data: () => {
    return {
      newcategory: [],
      categorywiseprod: [],
      cart: [],
      loading: false,
      loadingType: "loading",
      loadingMessage: "Uploading",
      category: [],
      vendorProducts: [],
      vendors: [],
      productimageandname: [],
      products: [],
      carts: [],
      dynamic_class: false,
      class: "col-md-8",
      dynamic_row: false,
      fruit: [],
      vegetable: [],
      dairyProducts: [],
      otherProducts: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      getDataCart: "getDataCart"
    })
  },
  mounted() {
    this.getCategoryData();
    this.getCartData();
    this.AddDynamicClass();
    this.getAllVendor();
    this.getProductsData();
  },
  components: {
    Cart,
    Category,
    Homeproduct: () => import("../components/Homeproduct")
  },
  methods: {
    getAllVendor() {
      this.$bind("vendors", dbFs.collection("vendor")).catch(error => {
        console.log(error);
      });
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("scroll-to-me")[0];

      if (el) {
        el.scrollIntoView();
      }
    },
    AddDynamicClass() {
      if (this.user) {
        this.dynamic_class = "col-md-10";
        this.dynamic_row = "row";
      } else {
        this.dynamic_class = "";
        this.dynamic_row = "";
      }
    },
    getCategoryData() {
      this.loading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Product Loading";
      this.loading = true;
      dbFs
        .collection("productCategory")
        .get()
        .then(res => {
          res.forEach(ele => {
            var data = ele.data();
            var obj = {
              id: ele.id,
              name: data.name,
              image: data.img
            };
            this.newcategory.push(obj);
          });
          this.collectall();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    collectall() {
      var tofetchproductname = [];
      this.newcategory.forEach(onecategory => {
        dbFs
          .collection("vendorProducts")
          .where("status", "==", true)
          .where("productCategoryId", "==", onecategory.id)
          .where("stock", ">", 1)
          .limit(6)
          .get()
          .then(res => {
            if (res.empty) {
              console.log("Category Not Availble");
            } else {
              var tempobj = [onecategory.name, onecategory.id];
              let product = [];
              res.forEach(doc => {
                var data = doc.data();
                data["id"] = doc.id;
                tempobj.push(data);
                product.push(data);
              });
              this.categorywiseprod.push(tempobj);
              tofetchproductname.push(product);
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            // tofetchproductname.forEach(onecat => {
            //   if (onecat.length > 2) {
            //     var index = 0;
            //     for (index; index <= 5; index++) {
            // dbFs
            //   .collection("products")
            //   .doc(onecat[index].productsId)
            //   .get()
            //   .then(innerdoc => {
            //     // res.forEach(innerdoc => {
            //     var obj = {
            //       id: innerdoc.id,
            //       name: innerdoc.data().name,
            //       image: innerdoc.data().image,
            //       productId: innerdoc.data().productId,
            //       unitType: innerdoc.data().unitType
            //     };
            //     this.productimageandname.push(obj);
            //     // });
            //   });
            //     }
            //   }
            // });
          });
      });
    },
    removenamenid(category, inx) {
      return category.slice(inx);
    },
    getProductsData() {
      this.loading = true;
      this.$bind(
        "productimageandname",
        dbFs.collection("products").where("status", "==", true)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.productimageandname.forEach(doc => {
            var xarr = doc.name.split(" ", 3);
            var xname = xarr[0] + " " + xarr[1] + " " + xarr[2];
            doc.name = xname;
          });
        });
    },
    getCartData() {
      this.loading = true;
      if (this.user) {
        this.$rtdbBind("carts", db.ref("carts/" + this.user.uid))
          .then(() => {
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.loadingError = true;
          });
      }
    },
    getProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.productimageandname)) {
        const product = this.productimageandname[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getCart,
    addToCart,
    getSellerName(id) {
      let seller = "";
      for (const cusKey of Object.keys(this.vendors)) {
        const product = this.vendors[cusKey];
        if (id == product.id) {
          seller = product.shopDetails.name;
        }
      }
      return seller;
    }
    // splitreturn(value) {
    //   let newkeyword = value.trim();
    //   return newkeyword;
    // },
    // UpdateAllProduct() {
    //   let pp = this.products;
    //   // let keys;
    //   for (const product of pp) {
    //     let productCategoryId = this.splitreturn(product.productCategory);
    //     console.log(productCategoryId);
    //     let customer = {
    //       productCategory: productCategoryId
    //     };
    //     dbFs
    //       .collection("products")
    //       .doc(product.id)
    //       .set(customer, { merge: true })
    //       .then(() => {});
    //   }
    // }
  },
  watch: {
    user() {
      this.dynamic_class = !this.dynamic_class;
      this.dynamic_row = !this.dynamic_row;
    }
  }
};
</script>
<style scoped>
/* .test {
  position: absolute;
  opacity: 0;
  background-color: #f69325;
  width: 384px;
  height: 327px;
} */

.xx:hover {
  background-color: #f69325;
}

.serviceimage {
  opacity: 1;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  font-size: 25px;
  color: white;
  font-weight: bold;
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.xx:hover .serviceimage {
  cursor: pointer;
  opacity: 0.2;
}

.xx:hover .middle {
  cursor: pointer;
  opacity: 1;
}

.pointer {
  cursor: pointer;
}
.uppercat {
  position: relative;
}
.catname-custom {
  height: 40px;
  padding: 7px 0;
  position: absolute;
  text-align: center;
  bottom: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.578);
  color: rgb(0, 0, 0);
  padding-left: 20px;
  padding-right: 20px;
}
.textx {
  float: right;
  width: 100%;
  text-align: right;
  position: absolute;
  color: white;
}
.insidetextx {
  font-weight: bold;
  background-color: black;
  padding: 0px 10px 5px 20px;
  font-size: 20px;
  border: 2px solid black;
  border-radius: 0px 0px 0px 30px;
}

@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
.VueCarousel {
  display: flex;
  flex-direction: column;
  position: relative;
}
.remove-atag {
  text-decoration: none;
  color: #51381b;
}
.slide-bar-view {
  margin-left: 130px;
  margin-right: 130px;
}
.add-to-cart {
  padding-top: 15px;
}
.add-to-cart button {
  width: 120px;
  height: 42px;
  border-radius: 33px;
}
.cart-add {
  font-size: 1em;
  color: #000000;
}
.product-other .name {
  height: 30px;
  font-size: 1em;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}
.product-other .price {
  font-size: 1em;
  height: 20px;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 1.2px;
  color: #51381b;
}
.product-other {
  padding-top: 1em;
}
.product-images {
  height: 233px;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 0px;
}
.product-images img {
  margin: auto;
}
.product-box {
  border-radius: 0px !important;
  width: 215px;
  height: 400px;
}
.btn-for-box {
  width: 100%;
  height: 100%;
  max-width: 257px;
  max-height: 85px;
  background-color: #1c1a1a;
  opacity: 0.8;
  border-radius: 33px;
  backdrop-filter: blur(9px);
  margin: auto;
}
.btn-for-box h4 {
  font-size: 1.5em;
  font-family: "Pacifico", cursive;
  color: #ffffff;
  letter-spacing: 2.88px;
  padding-top: 15px;
  text-align: center;
}
.btn-for-box p {
  font-size: 1em;
  font-family: "Montserrat-Regular";
  color: #ffffff;
  letter-spacing: 0.51px;
  /* padding-top: 5px; */
  text-align: center;
}
.category-wise-item {
  margin-left: 50px;
  margin-right: 50px;
}
.category-wise-item .category-name {
  font-size: 34px;
  color: #313131;
  font-weight: bold;
}
.category-list {
  margin-left: 5px;
  margin-right: 5px;
}
.categoryImage {
  width: 376px;
  height: 242px;
}
.category {
  padding-left: 15px;
  padding-right: 15px;
}
.category-box-1 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/1.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-2 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/2.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-3 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/3.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-4 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/4.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-inside:hover {
  background-color: #51381b;
  opacity: 0.9;
  margin: auto;
}
.category-box-inside {
  height: 100%;
  margin: 0 auto;
  width: 100%;
  padding-top: 30%;
}
.primary-color {
  color: #17aa18;
}
@media only screen and (max-width: 1068px) {
  .media-query {
    display: none;
    background-color: #ffffff !important;
  }
}
</style>
